import { getAppConfiguration } from '@mews-commander/data-access';
import { PlatformEnvironment } from '@mews/enums';
import { AppError } from '@mews/framework';
import { WS_BASE_URL } from '../../../constants';

/** @deprecated useAppConfiguration().nowUtc */
export const getServerNowUtc = () => {
    const { nowUtc } = getAppConfiguration();
    if (!nowUtc) {
        throw new AppError('Server nowUtc is not set');
    }
    return nowUtc;
};

/** @deprecated useAppConfiguration().version */
export const getVersion = () => getAppConfiguration().version;
/** @deprecated useAppConfiguration().environment */
export const getPlatformEnvironment = () => getAppConfiguration().environment;
/** @deprecated useAppConfiguration().platformPrimaryUrl */
export const getPlatformPrimaryUrl = () => getAppConfiguration().platformPrimaryUrl;
/** @deprecated useAppConfiguration().platformApiUrl */
export const getPlatformApiUrl = () => getAppConfiguration().platformApiUrl;
/** @deprecated useAppConfiguration().assetBaseUrl */
export const getAssetBaseUrl = () => getAppConfiguration().assetBaseUrl;
/** @deprecated useAppConfiguration().imageBaseUrl */
export const getImageBaseUrl = () => getAppConfiguration().imageBaseUrl;

/**
 * Gets a base path prefix for application urls.
 * @deprecated useAppConfiguration().routerBaseUrl */
export const getRouterBaseUrl = () => getAppConfiguration().routerBaseUrl;
/** @deprecated useAppConfiguration().pciProxyScriptUrl */
export const getPciProxyScriptUrl = () => getAppConfiguration().pciProxyScriptUrl;
/** @deprecated useAppConfiguration().cookieFirstToken */
export const getCookieFirstToken = () => getAppConfiguration().cookieFirstToken;
/** @deprecated useAppConfiguration().platformWebSocketUrl + WS_BASE_URL */
export const getWebsocketUrl = () => getAppConfiguration().platformWebSocketUrl + WS_BASE_URL;

/** @deprecated useAppConfiguration().environment */
export const isProduction = () => getPlatformEnvironment() === PlatformEnvironment.Production;
/** @deprecated useAppConfiguration().environment */
export const isDemo = () => getPlatformEnvironment() === PlatformEnvironment.Demo;
/** @deprecated useAppConfiguration().environment */
export const isDevelopment = () => getPlatformEnvironment() === PlatformEnvironment.Development;

/**
 * Gets a base path prefix for old MVC urls. Used by TemplateFetcher and POST forms submitted to controllers.
 * Should never be anything else than `/Commander`.
 * @deprecated useAppConfiguration().serverBasePath */
export const getServerBasePath = () => getAppConfiguration().serverBasePath;
